export const productCategories = [
  { name: "Diagnostic devices", link: "/products/diagnostic-devices" },
  {
    name: "Surgical instruments",
    link: "/products/surgical-instruments",
  },
  { name: "Mobility aids", link: "/products/mobility-aids" },
  {
    name: "Lab consumables",
    link: "/products/lab-consumables",
  },
  { name: "Wound care items", link: "/products/wound-care-items" },
  {
    name: "Infection control items",
    link: "/products/infection-control-items",
  },
  {
    name: "Infusion & injection items",
    link: "/products/infusion-and-injection-items",
  },
];
